import AccountRecoveryMessage from './AccountRecoveryMessage'
export default AccountRecoveryMessage
